import { render, staticRenderFns } from "./QuarterColumn.vue?vue&type=template&id=f146d250&scoped=true"
import script from "./QuarterColumn.vue?vue&type=script&lang=js"
export * from "./QuarterColumn.vue?vue&type=script&lang=js"
import style0 from "./QuarterColumn.vue?vue&type=style&index=0&id=f146d250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f146d250",
  null
  
)

export default component.exports